import { useQuery } from "@tanstack/react-query";
import TeamsDomain from "../domainActions/TeamsDomain";
export const teamQueryKey = (teamId) => ["team", teamId];
const useTeam = (teamId) => useQuery({
  queryKey: teamQueryKey(teamId),
  // Delegate to TeamsDomain.load (not the bare loadTeam api fn) to keep the notFoundRedirect: true + error-notify wrapper.
  queryFn: () => TeamsDomain.load(teamId),
  enabled: !!teamId,
  retry: false
});
export default useTeam;
